import getCdnUrl from '@fingo/lib/helpers/get-cdn-url';

const Home = getCdnUrl('/landings/home-desktop@2x-80q.webp');

export default Home;
